<template>
  <div id="evaluate-question">
    <!-- <widgetdrag ref="widgetdrag" v-show="changjiangyida === false" :timuData="timuData" @changeOverFlow="bodyItem" @JumpPage="changePage" @JumpTo="jump"></widgetdrag> -->
    <!-- <div v-show="changjiangyida === true"> -->
    <div>
      <div class="bj" v-if="alertShow">
        <div class="box">
          <img src="../assets/chaoshi.png" style="margin:30px 0 10px 0;width: 50px;" /><br />
          <div style="color:#C41335;font-size:24px;">超时啦!</div>
          <span style="display: inline-block;width:66%;font-size:16px;font-weight:400;line-height:30px;">您的消防安全评测用时已结束 </span><br />
          <div style="display:inline-block;background:rgba(196,19,53,1);border-radius:27px;color:rgba(255,255,255,1);line-height:44px;padding:0 20px;margin:30px 0 0 0;">{{daojishi+1}}s 自动跳转至结果页</div><br />
          <img @click="alertShow=false" style="margin-top:45px;width:40px;" src="../assets/close.png" />
        </div>
      </div>
      <evaluator-header class="mainHeader" @logout="logoutClick"></evaluator-header>
      <div style="position:relative;display:flex;line-height:30px;text-align: center;width:100%;z-index:900" :class="[atTop === true ? 'fixclass' : '']">
        <div v-if="jishikaiqi==1" style=";background:#11304F;width:50%;line-height:50px;">
          <span style="color:#FFFFFF;font-size:10px;">倒计时 ：</span>
          <span style="color:#0EEBFF;font-size:17px;font-weight: bold;">{{daojishiString}}</span>
        </div>
        <div @click="infoShow = !infoShow" :style="{width:setwidth+'%'}" style="position:relative;background:#17456C;color:#FFFFFF;line-height:50px;">
          题目
          <img v-show="!infoShow" style="width:10px;margin-left:14px;" src="../assets/xiangxia.png" />
          <img v-show="infoShow" style="width:10px;margin-left:14px;" src="../assets/xiangshang.png" />
        </div>
        <div v-if="infoShow" style="border-bottom:1px solid #123756;position:absolute;top:50px;background:#17456C;width:100%;text-align: left;padding:0 20px;">
          <div style="border-bottom:1px solid #123756;padding:11px 0;">
            <div class="topTitle" style="line-height:20px;color:#FFFFFF">企业信息</div>
            <div style="color:#0EEBFF;">{{name}}</div>
          </div>
          <!-- <div style="border-bottom:1px solid #123756;padding:11px 0;">
            <div class="topTitle" style="line-height:20px;color:#FFFFFF">场景题目</div>
            <div class="changjing" @click="JumpBack">模拟场景</div>
          </div> -->
          <div style="border-bottom:1px solid #123756;padding: 11px 0px 20px 0;">
            <div class="topTitle" style="line-height:20px;color:#FFFFFF">答题卡</div>
            <a class="tibiao" :class="{'bordershow':borderindex==i,'yida':item.isda}" @click="dianji(i)" v-for="(item,i) in timuData" :key="i">{{i+1}}</a>
          </div>
        </div>
      </div>
      <div style="background:#F9F9F9;padding:0 0 60px 0;" :style="{'padding-top':paddingtop+'px'}">
        <div class="tishi">《 消防安全知识 》评测</div>
        <div v-for="(item,i) in timuData" :key="i" :id="i">
          <!--  单选  -->
          <div v-if="item.que_type==1" class="timu" :class="{'weitian':!item.isda&&isclick}">
            <div class="title">{{i+1}}. {{item.que_content}}<span class="beizhu"> ( 单选 )</span></div>
            <div v-for="(list,index) of item.riskevalAnswerList" :key="index">
              <el-radio class="xuanxiang" @change="radioChange(item,list)" v-model="item.as" :label="list.id">{{list.answer_content}}</el-radio>
              <div v-if="list.childQuestion!==undefined">
                <!--单选题---------------------- -->
                <div class="ziti" v-if="list.childQuestion.que_type==1&&(item.daan=='有'||item.daan=='是')">
                  <span class="title" style="font-size: 14px;">{{list.childQuestion.que_content}}</span>
                  <div v-for="(list1,ind) of list.childQuestion.riskevalAnswerList" :key="ind">
                    <el-radio class="xuanxiang" @change="zitichange(item,list1)" v-model="list.childQuestion.as" :label="list1.id">{{list1.answer_content}}</el-radio>
                  </div>
                </div>
                <!--多选题---------------------- -->
                <div class="ziti" v-else-if="list.childQuestion.que_type==2&&(item.daan=='有'||item.daan=='是')">
                  <span class="title" style="font-size: 14px;">{{list.childQuestion.que_content}}</span>
                  <el-checkbox-group v-model="list.childQuestion.as">
                    <div v-for="(list1,ind) of list.childQuestion.riskevalAnswerList" :key="ind">
                      <el-checkbox class="xuanxiang" @change='checkboxChange(list.childQuestion,list1,item)' :label="list1.id" :value="list1.id">{{list1.answer_content}}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
            <span v-if="!item.isda&&isclick" class="weida"> 请完成答题</span>
          </div>
          <!--多选题---------------------- -->
          <div class="timu" v-else-if="item.que_type==2||item.que_type==3" :class="{'weitian':!item.isda&&isclick}">
            <span class="title">{{i+1}}.{{item.que_content}}</span>
            <span class="beizhu"> (多选)</span>
            <el-checkbox-group v-model="item.as">
              <div v-for="(list,ind) of item.riskevalAnswerList" :key="ind">
                <el-checkbox class="xuanxiang" @change='checkboxChange(item,list)' :label="list.id" :value="list.id">{{list.answer_content}}</el-checkbox>
              </div>
            </el-checkbox-group>
            <span v-if="!item.isda&&isclick" class="weida"> 请完成答题</span>
          </div>
        </div>
      </div>
      <bottomButton v-show="!disabled" @click="submit" id="bottomButton" title="提交" :state="1"></bottomButton>
      <bottomButton v-show="disabled" @click="submit1" id="bottomButton" title="提交" :state="0"></bottomButton>
    </div>
  </div>
</template>

<script>
import bottomButton from '../components/bottom-button'
import { Toast } from 'mint-ui'
import evaluatorHeader from '../view/evaluator-header'
import axios from 'axios'
// import widgetdrag from '../components/widgetDrag'
export default {
  data () {
    return {
      headershow: true,
      dingshiqian: null,
      daojishi: null,
      // changjiangyida: false,
      daojishiString: '00:00',
      timuData: [],
      atTop: false,
      paddingtop: 0,
      setwidth: 50,
      datiNum: 1,
      borderindex: null,
      disabled: true,
      jishikaiqi: '1',
      n1: 0,
      n2: 0,
      name: '',
      infoShow: false,
      alertShow: false,
      isclick: false,
      getterList: {},
      resultList: []
    }
  },
  components: {
    bottomButton,
    evaluatorHeader
    // widgetdrag
  },
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      if (login === 0) {
        Toast('您还未登录，请登录后再评测！')
        _this.$router.push({ path: 'home' })
      }
    })
    document.documentElement.scrollTop = document.body.scrollTop = 0
    window.addEventListener('scroll', this.handleScroll, true)
    this.gettimu()
    this.getCunterTime()

    this.getData()
  },
  methods: {
    logoutClick: function () {
      // 退出登录
      this.$router.push({ path: 'home' })
    },

    getData () {
      this.utils.GET(
        this.accountUrl +
              // this.$api.get(
              '/riskevalInteraction/getInteractionQuestion',
        res => {
          this.getterList = res.data
          let resuleobj = {
            created_time: this.getterList.created_time,
            id: this.getterList.id,
            interaction_duration: 0,
            interaction_question: this.getterList.interaction_question,
            master_map: this.getterList.master_map,
            modified_time: this.getterList.modified_time,
            put_area: this.getterList.put_area,
            result_id: this.getterList.result_id,
            score: this.getterList.score,
            site_category_name: this.getterList.site_category_name,
            // tails: "(...)",
            total_score: this.getterList.total_score,
            widget_ids: this.getterList.widget_ids,
            widget_location: this.getterList.widget_location,
            judge_results: [{'area': 0, 'judge_result': 1}, {'area': 1, 'judge_result': 1}, {'area': 2, 'judge_result': 1}, {'area': 3, 'judge_result': 1}, {'area': 4, 'judge_result': 1}],
            record_data: [{'customid': 1578647166809, 'id': 1, 'x': 0, 'y': 20}, {'customid': 1578647167048, 'id': 1, 'x': 0, 'y': 20}, {'customid': 1578647167274, 'id': 1, 'x': 0, 'y': 20}, {'customid': 1578647167528, 'id': 1, 'x': 0, 'y': 20}, {'customid': 1578647167810, 'id': 1, 'x': 0, 'y': 20}]
          }

          axios({
            method: 'post',
            url: this.accountUrl + '/riskevalInteraction/commitInteractionRecord',
            data: resuleobj,
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              'Cache-control': 'no-cache',
              Pragma: 'no-cache',
              Expires: 0,
              zxzxkey: ''
            },
            dataType: 'json'
          }).then(res => {
          })
        }
      )
    },
    // jump (val) {
    //   var that = this
    //   setTimeout(function () {
    //     that.dianji(val)
    //   }, 200)
    // },
    // JumpBack () {
    //   window.clearInterval(this.dingshiqian)
    //   this.changjiangyida = false
    //   this.infoShow = false
    //   window.onorientationchange = this.$refs.widgetdrag.backAndChange
    //   document.documentElement.scrollTop = document.body.scrollTop = 0
    //   this.$refs.widgetdrag.backAndChange(this.changjiangyida)
    // },
    // bodyItem (val) {
    //   if (this.changjiangyida === false) {
    //     document.body.style.overflow = val
    //   }
    // },

    getCunterTime () {
      this.utils.GET(
        this.accountUrl + '/riskevalNew/getQuestionDurationSet',
        res => {
          if (res.data.status === 1) {
            // let that = this
            this.jishikaiqi = 1
            this.n1 = new Date().getTime()
            // this.conterStatus = res.data.status
            this.daojishi = parseInt(res.data.durationLimit)
            window.clearInterval(this.dingshiqian)
            this.dingshiqian = setInterval(() => {
              this.setjishi()
            }, 1000)
            this.setwidth = 50
            // this.daojishi = 10;
          } else {
            this.jishikaiqi = 0
            this.setwidth = 100
          }
        }
      )
    },

    // changePage (obj) {
    //   this.n1 = new Date().getTime() // 跳到我这边页面的时候就开始记时
    //   this.jishikaiqi = obj.conterstatus
    //   this.changjiangyida = obj.changjiangyida
    //   if (this.jishikaiqi === 1) {
    //     this.daojishi = obj.daojishi
    //     this.setwidth = 50
    //     // this.daojishi = 20;
    //     this.setjishi()
    //     var that = this
    //     window.clearInterval(this.dingshiqian)
    //     this.dingshiqian = setInterval(function () {
    //       that.setjishi()
    //     }, 1000)
    //   } else {
    //     this.setwidth = 100
    //   }
    // },
    // 滚动判断是否显示右侧导航和头部显示哪个导航
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= 55) {
        this.atTop = true
        this.paddingtop = 50
      } else {
        this.atTop = false
        this.paddingtop = 0
      }
      // if (scrollTop <= 60) {
      //   // this.top = 55
      //   // this.paddingtop = 53
      // } else {
      //   // this.top = 0
      //   // this.paddingtop = 97
      // }
    },
    getTimes (item) {
      this.n2 = new Date().getTime()
      if (item.time === undefined) {
        this.$set(item, 'time', this.n2 - this.n1)
      } else {
        this.$set(item, 'time', item.time + (this.n2 - this.n1))
      }
      this.n1 = this.n2
    },
    setjishi () {
      if (this.daojishi >= 0) {
        var fenzhong = parseInt((this.daojishi % 3600) / 60)
        fenzhong = fenzhong >= 10 ? fenzhong : '0' + fenzhong
        var miao = this.daojishi % 60
        miao = miao >= 10 ? miao : '0' + miao
        this.daojishiString = fenzhong + ':' + miao
        this.daojishi--
      }
      if (this.daojishi == 4) {
        this.alertShow = true
      } else if (this.daojishi == -1) {
        this.alertShow = false
        window.clearInterval(this.dingshiqian)
        this.submit()
      }
    },
    dianji (i) {
      this.borderindex = i
      this.infoShow = false
      if (i < 2) {
        window.scrollTo(0, 0)
      } else {
        var obj = document.getElementById(i)
        window.scrollTo(0, obj.offsetTop - 110)
      }
    },
    checkboxChange (item, list, zichuanitem) {
      if (item.id == 8 && item.as.length > 4) {
        // 这道题只能选四个
        item.as.pop()
      }
      if (list.answer_content == '都没有') {
        item.as = []
        item.as.push(list.id)
      } else {
        let doumeiyouId = ''
        for (let i = 0; i < item.riskevalAnswerList.length; i++) {
          // eslint-disable-next-line no-unused-expressions
          item.riskevalAnswerList[i].answer_content === '都没有' ? (doumeiyouId = item.riskevalAnswerList[i].id) : ''
        }
        for (let i = 0; i < item.as.length; i++) {
          // eslint-disable-next-line no-unused-expressions
          item.as[i] === doumeiyouId ? item.as.splice(i, 1) : ''
        }
      }
      this.dati()
      this.getTimes(item)
    },
    zitichange (item, list1) {
      this.dati()
      this.getTimes(item)
    },
    radioChange (item, list) {
      this.$set(item, 'daan', list.answer_content)
      this.dati()
      this.getTimes(item)
    },
    dati () {
      this.infoShow = false
      this.datiNum = 1
      this.timuData.forEach((item, i) => {
        if (this.isEmpty(item.as)) {
          this.$set(this.timuData[i], 'isda', false)
        } else if (item.daan === '有' || item.daan === '是') {
          for (var j = 0; j < item.riskevalAnswerList.length; j++) {
            var list = item.riskevalAnswerList[j]
            if (
              list.childQuestion !== undefined &&
              (list.answer_content === '有' || list.answer_content === '是')
            ) {
              if (this.isEmpty(list.childQuestion.as)) {
                this.$set(this.timuData[i], 'isda', false)
              } else {
                this.$set(this.timuData[i], 'isda', true)
                this.datiNum++
              }
            }
          }
        } else {
          this.$set(this.timuData[i], 'isda', true)
          this.datiNum++
        }
      })
      this.disabled = this.datiNum !== this.timuData.length + 1 // 所有题目是否已经答完
    },
    gettimu () {
      // 获取18道 安全意识题
      var that = this
      this.utils.GET(this.accountUrl + '/riskevalNew/getNewQuestion', function (
        res
      ) {
        that.timuData = res.data
        that.name = res.ent.ent_name
        that.timuData.forEach((item, i) => {
          that.$set(that.timuData[i], 'isda', false) // 记录是否答题
          if (item.que_type === 1) {
            that.$set(that.timuData[i], 'as', '')
            var list = that.timuData[i].riskevalAnswerList
            for (var j = 0; j < list.length; j++) {
              if (list[j].childQuestion !== undefined) {
                that.$set(list[j].childQuestion, 'as', [])
              }
            }
          } else if (item.que_type === 2 || item.que_type === 3) {
            that.$set(that.timuData[i], 'as', [])
          }
        })
      })
    },
    submit1 () {
      this.isclick = true
      var index = this.timuData.findIndex((v, i) => { return v.isda === false })
      this.dianji(index)
    },
    submit () {
      var datas = []
      this.timuData.forEach((item, i) => {
        if (item.isda) {
          // 已经答题
          if (item.que_type === 1 && (item.daan === '有' || item.daan === '是')) {
            var list = item.riskevalAnswerList[0].childQuestion
            if (Array.isArray(list.as)) {
              datas.push({id: list.id, answer_ids: list.as.join(), duration: item.time})
            } else {
              datas.push({id: list.id, answer_ids: list.as, duration: item.time})
            }
          } else {
            if (Array.isArray(item.as)) {
              datas.push({id: item.id, answer_ids: item.as.join(), duration: item.time})
            } else {
              datas.push({id: item.id, answer_ids: item.as, duration: item.time})
            }
          }
        } else {
          datas.push({ id: item.id, answer_ids: '', duration: 0 })
        }
      })
      axios({
        //  上传答题答案
        method: 'post',
        url: this.accountUrl + '/riskevalNew/commitQuestion',
        data: datas,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'Cache-control': 'no-cache',
          Pragma: 'no-cache',
          Expires: 0,
          zxzxkey: '',
          Systemtype: 'mobile',
          phone: this.$route.query.phoneNumber
        },
        dataType: 'json'
      }).then(res => {
        if (res.data.code === 0) {
          if (this.jishikaiqi === 1) {
            window.clearInterval(this.dingshiqian)
          }
          // document.removeEventListener('touchstart', this.$refs.widgetdrag.startTouch)
          // document.removeEventListener('touchmove', this.$refs.widgetdrag.startMove, {passive: false})
          this.$router.replace({path: '/fxcp_result', query: { result_id: res.data.data.result_id }})
        }
      })
    }
  },
  watch: {},
  computed: {}
}
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }
  .fixclass{
    position: fixed !important;
    top: 0;
  }
  .wrapper {
    background: #f9f9f9;
    padding-bottom: 84px;
    color: #000000;
    font-family: Microsoft YaHei;
    font-size: 16px;
    line-height: 36px;
  }
  .title1 {
    line-height: 54px;
    background: #ffffff;
    padding: 0 0 0 15px;
    font-weight: bold;
  }
  .timu {
    margin: 10px 0 0 0;
    padding: 20px 15px;
    background: #ffffff;
    position: relative;
  }
  .inputs {
    width: 100%;
    height: 50px;
    background: white;
    border: 0.5px solid #dadada;
    padding: 0 0 0 20px;
    margin-bottom: 20px;
  }
  .title {
    font-weight: bold;
    font-size: 15px;
    color: #000000;
  }
  .beizhu {
    font-weight: 400;
    color: #808080;
    font-size: 12px;
  }
  .bj {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10000;
  }
  .box {
    width: 88%;
    height: 266px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    text-align: center;
  }
  .changjing {
    color: #123756;
    line-height: 25px;
    display: inline-block;
    width: 73px;
    background: #0eebff;
    border-radius: 4px;
    text-align: center;
    font-size: 12px;
    margin-top: 6px;
  }
  .tibiao {
    display: inline-block;
    width: 28px;
    line-height: 26px;
    text-align: center;
    background: #081724;
    margin: 5px 6px 0 0;
    font-size: 12px;
    color: #bbd2ff;
    border-radius: 5px;
    border: 2px solid #081724;
  }
  .yida {
    background: #0eebff;
    color: #123756;
    border: 2px solid #0eebff;
  }
  .bordershow {
    border: 2px solid #08808b;
  }
  .feigexian {
    padding: 10px 0;
    border-bottom: 1px solid #eeeeee;
  }
  .xuanxiang {
    display: flex;
    align-items: center;
    line-height: 20px !important;
    margin-top: 15px;
  }
  .weitian {
    /*background: #fff7f7;*/
    border: 1px solid #fecdcd;
  }
  .beizhu {
    font-weight: 400;
    color: #808080;
    font-size: 14px;
  }
  .ziti {
    margin: 12px 0 0 0;
    width: 100%;
    background: rgba(249, 249, 249, 1);
    border: 1px solid rgba(218, 218, 218, 1);
    padding: 10px 20px;
  }
  .weida {
    position: absolute;
    bottom: 1px;
    right: 1px;
    padding: 3px 20px 3px 45px;
    color: #c41335;
    font-size: 13px;
    line-height: 20px;
    background: url(../assets/gantanhao.png) no-repeat;
    background-size: 15px;
    background-position: 21px 5px;
    background-color: #fff7f7;
  }
  .tishi {
    font-size: 18px;
    line-height: 46px;
    background: #ffffff;
    font-weight: bold;
    padding: 0 0 0 7px;
    color: #000000;
  }
</style>
<style type="text/css">
  .el-radio__inner,
  .el-checkbox__inner {
    height: 20px !important;
    width: 20px !important;
    border-radius: 10px !important;
  }
  .el-checkbox__inner::after {
    height: 9px !important;
    left: 6px !important;
    top: 3px !important;
    width: 4px !important;
  }
  .el-checkbox__label,
  .el-radio__label {
    white-space: normal;
  }
  .el-radio__input.is-checked .el-radio__inner,
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #c41335 !important;
    border-color: #c41335 !important;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label,
  .el-radio__input.is-checked + .el-radio__label {
    color: #c41335 !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/fxcp_anquan.vue